import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../support/with_presenter';
import {MediaPresenter} from './MediaPresenter';
import {If} from '../../../../components/if';
import {PartComponent} from '../components/PartComponent';
import {calculatePartHeightPx} from '../support/calculatePartHeightPx';
import {MediaItemList} from './MediaItemList/MediaItemList';

interface OwnProps {
    onSubmit: () => void;
}

const MediaComponent: FunctionComponent<OwnProps & PresenterProps<MediaPresenter>> = observer(
    ({presenter, onSubmit}) => {
        if (presenter.loading) {
            return (
                <div className="training-plan-editor__loading">
                    <div />
                    <div />
                    <div />
                </div>
            );
        }
        return (
            <>
                <If condition={presenter.expandedParts.length === 0}>
                    <div className="training-plan-editor__empty">
                        <div />
                        <div />
                        <div />
                    </div>
                </If>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="timeline">
                            {presenter.expandedParts.map((expandedPart) => (
                                <PartComponent
                                    key={expandedPart.__uuid}
                                    part={expandedPart.part}
                                    height={calculatePartHeightPx(expandedPart.part)}
                                >
                                    <MediaItemList expandedPart={expandedPart} media={presenter.media} />
                                </PartComponent>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <button
                            className="btn btn-primary pull-right icon-left ion-md-checkmark"
                            onClick={() => onSubmit()}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </>
        );
    },
);

export const Media = withPresenter<MediaPresenter, OwnProps>(
    (props, component) => new MediaPresenter(component.expandedPartsProvider, component.mediaProvider),
    MediaComponent,
);
